import { format } from 'date-fns';

const formatDateLocal = (dateString) => {
    if (!dateString) return '-';
    return format(new Date(dateString), "dd/MM/yyyy HH:mm:ss");
};

export default formatDateLocal;
